import { render, staticRenderFns } from "./intransfer_stock.vue?vue&type=template&id=677d6985&"
import script from "./intransfer_stock.vue?vue&type=script&lang=js&"
export * from "./intransfer_stock.vue?vue&type=script&lang=js&"
import style0 from "./intransfer_stock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports